import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { CachedDataService } from '@services/data/cached-data.service';
import { Observable } from 'rxjs/Observable';
import { DeviceState } from '@models/device-state';
import { BaseHttpService } from '@services/http/base-http.service';
import { Router } from '@angular/router';
import { AuthService } from '@services/http/auth.service';



import { StatsItem, Track, StatsTrack, DeviceEvent, DailyQuality, GraphQuality, CaptchaItem } from '@models';

/*Eenvironment */
import { environment } from '@environments';

@Injectable()
export class DevicesService extends BaseHttpService {

  constructor(protected httpClient: HttpClient,
    protected cachedDataService: CachedDataService,
    protected router: Router,
    protected authService: AuthService) {
    super(httpClient, cachedDataService, router, authService);
  }

  getDeivesByObjectId(objectId: string): Observable<any> {
    const uri = environment.apiUri + `device/search?ObjectOrSharedObjectId=${objectId}&isExtended=true&PageSize=10000`;
    return super.send('GET', uri);
  }


  getState(deviceId: string, captchaBody?: CaptchaItem): Observable<DeviceState> {
    let params;
    if( captchaBody){
      params = new HttpParams()
        .set('capchaId', captchaBody.capchaId)
        .set('capchaCode', captchaBody.capchaCode);
    }
  
    const uri = `${environment.apiUri}device/${deviceId}/state`;
    if(params){
      return super.send<DeviceState>('GET', uri, params);
    }else{
      return super.send<DeviceState>('GET', uri);
    }
  }

  getEvents(deviceId: string, from: number, to: number): Observable<DeviceEvent[]> {
    const uri = environment.apiUri + 'event';
    const params = new HttpParams()
      .set('from', from.toString())
      .set('to', to.toString())
      .set('deviceId', deviceId);

    return super.send('GET', uri, params);
  }

  getEventDetails(deviceId: string, eventId: string, timestamp: number): Observable<DeviceEvent> {
    const uri = environment.apiUri + 'event/state';
    const params = new HttpParams()
      .set('deviceId', deviceId)
      .set('eventId', eventId)
      .set('timestamp', timestamp.toString());

    return super.send('GET', uri, params);
  }

  getHistory(deviceId: string, type: string, from: number, to: number): Observable<StatsItem[]> {
    const uri = environment.apiUri + 'stats';
    const params = new HttpParams()
      .set('deviceId', deviceId)
      .set('type', type)
      .set('from', from.toString())
      .set('to', to.toString());

    return super.send('GET', uri, params);
  }

  getStats(deviceId: string): Observable<Track[]> {
    const uri = environment.apiUri + 'stats/summary';
    const params = new HttpParams()
      .set('deviceId', deviceId);

    return super.send('GET', uri, params);
  }

  getStatsTrack(deviceId: string, from: number, to: number): Observable<StatsTrack[]> {
    const uri = environment.apiUri + 'stats/track';
    const params = new HttpParams()
      .set('deviceId', deviceId)
      .set('from', from.toString())
      .set('to', to.toString());

    return super.send('GET', uri, params);
  }

  getTracks(deviceId: string, from: number, to: number): Observable<Track[]> {
    const uri = environment.apiUri + 'track';
    const params = new HttpParams()
      .set('deviceId', deviceId)
      .set('from', from.toString())
      .set('to', to.toString());

    return super.send('GET', uri, params);
  }

  getCommand(deviceId: string): Observable<any> {
    const uri = environment.apiUri + 'command';
    const params = new HttpParams()
      .set('deviceId', deviceId);
    return super.send('GET', uri, params);
  }

  sendCommand(id: string, deviceId: string, provider: string, cCode?: string): Observable<any> {
    const uri = environment.apiUri + 'command';
    const body: object = {
      id: id,
      deviceId: deviceId,
      provider: provider
    };
    if (cCode) {
      body['CommandText'] = `ccode=${cCode}`;
    }
    return super.send('POST', uri, null, true, body);
  }

  getCommandGroups(deviceId: string): Observable<any> {
    const uri = environment.apiUri + 'command/group';
    const params = new HttpParams()
      .set('deviceId', deviceId);
    return super.send('GET', uri, params);
  }

  createDevice(body: object): Observable<any> {
    const uri = environment.apiUri + 'device';
    return super.send('POST', uri, null, true, body);
  }

  updatePhone(deviceId: string, number: string, id: string) {
    const uri = environment.apiUri + `device/${deviceId}/phone`;
    const body = {
      number: number,
      id: id,
      usagetype: 'main',
    };
    return super.send('PUT', uri, null, true, body);
  }

  updatePassword(password: string, oldPassword: string, ProviderAccountId: string, isLocal: boolean, capchaId?:string, capchaCode?:string): Observable<any> {
    const uri = environment.apiUri + 'provideraccount/password';
    const body = {
      password: password,
      ProviderAccountId: ProviderAccountId,
      isLocal: isLocal
    };
    if(oldPassword!=null){
      body['oldPassword'] = oldPassword;
    }
    if(capchaId && capchaCode){
      body['capchaId'] = capchaId;
       body['capchaCode'] = capchaCode;
    }
    return super.send('PUT', uri, null, true, body);
  }

  getDailyQuality( deviceId: string, provider: string, date: number): Observable<DailyQuality> {
    const uri = environment.apiUri + `device/${deviceId}/insurance?date=${date}&provider=${provider}`;
   
    return super.send('GET', uri);
  }
  getPeriodQuality( deviceId: string, provider: string, from: number, to: number, isDay: boolean): Observable<GraphQuality> {
    const uri = environment.apiUri + `device/${deviceId}/insuranceHistory?from=${from}&to=${to}&grouping=${ isDay ? "day" : "month"}&provider=${provider}`;
   
    return super.send('GET', uri);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http/devices.service.ts